import LogoCollapsed from "@/assets/logo-breedr-collapsed@2x.png";
import Logo from "@/assets/logo-breedr@2x.png";

type LogoProps = {
  className?: string;
  variant: "collapsed" | "default";
  size?: keyof typeof sizeClasses;
};

const sizeClasses = {
  sm: "h-10",
  md: "h-12",
  lg: "h-14",
  xl: "h-16",
} as const;

export function BreedrLogo(props: LogoProps) {
  return (
    <img
      src={props.variant === "collapsed" ? LogoCollapsed : Logo}
      alt="Breedr logo"
      className={`
        ${sizeClasses[props.size ?? "md"]}
        ${props.className ?? ""}
      `}
    />
  );
}
